<app-navbar [title]="pageTitle">
	<button mat-raised-button color="primary" class="me-3" *ngIf="editable" (click)="submitAndExit()">
		Zapisz i wyjdź
	</button>
	<button mat-raised-button color="accent" class="me-3" *ngIf="editable" (click)="submitAndStay()">
		Zapisz i zostań
	</button>
	<button mat-raised-button color="primary" class="me-3" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
	<a mat-raised-button color="warn" (click)="back()"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#primaryData"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				>Dane podstawowe</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="other-tab"
				data-bs-toggle="tab"
				href="#location"
				role="tab"
				aria-controls="other"
				aria-selected="false"
				>Lokalizacje</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="stawki-tab"
				data-bs-toggle="tab"
				href="#multimedia"
				role="tab"
				aria-controls="multimedia"
				aria-selected="false"
				>Multimedia</a
			>
		</li>
	</ul>
	<div class="my-4">
		<div class="tab-content col" id="myTabContent">
			<div class="tab-pane fade active show" id="primaryData" role="tabpanel" aria-labelledby="podstawowe-tab">
				<app-optional-trip-basic [(data)]="data" [editable]="editable"> </app-optional-trip-basic>
			</div>
			<div class="tab-pane fade" id="multimedia" role="tabpanel" aria-labelledby="multimedia">
				<app-optional-trip-multimedias [(data)]="data" [editable]="!editable"> </app-optional-trip-multimedias>
			</div>
			<div class="tab-pane fade" id="location" role="tabpanel" aria-labelledby="location">
				<app-optional-trip-locations [(data)]="data" [editable]="!editable"> </app-optional-trip-locations>
			</div>
		</div>
	</div>
</div>
